import { useEffect, useState } from 'react'
import type { IFoodtable } from 'models/IFeed'
import FoodtableApiService from 'services/foodtableApiServices'
import { useWidgetPreview } from '../context/WidgetPreviewContext'
import { FOODTABLE_MOCK } from '../mocks/foodtableMock'

export const useWidgetFoodtable = () => {
	const { isPreview } = useWidgetPreview()
	const [foodtableInfo, setFoodtableInfo] = useState<IFoodtable[]>([])
	const [initialFoodtableInfo, setInitialFoodtableInfo] = useState<
		IFoodtable[]
	>([])
	const [isLoading, setIsLoading] = useState(!isPreview)

	useEffect(() => {
		if (isPreview) {
			setFoodtableInfo(FOODTABLE_MOCK)
			setInitialFoodtableInfo(FOODTABLE_MOCK)
			setIsLoading(false)
			return
		}

		setIsLoading(true)
		FoodtableApiService.getFoodtableReachAndUnreachInfo()
			.then(response => {
				const data = response.data
				setFoodtableInfo(data)
				setInitialFoodtableInfo(data)
			})
			.catch(error => {
				console.error(error.message)
			})
			.finally(() => setIsLoading(false))
	}, [isPreview])

	return {
		foodtableInfo,
		initialFoodtableInfo,
		isLoading,
		setFoodtableInfo,
	}
}
